module.exports = __webpack_public_path__ + "img/line-logo.31214ab0.png";